import React, { useMemo } from 'react';
import { Translation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    ...theme.component.dialogPaper,
    border: theme.component.border,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 24,
      marginRight: 24,
    },
  },
  dialogContent: {
    paddingTop: 16,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  imageGrid: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  confirmGrid: {
    textAlign: 'center',
  },
  dialogActions: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  deleteButton: {
    background: theme.palette.danger.main,
    borderRadius: '4px',
  },
  progressBar: {
    padding: '0px !important',
    marginTop: '8px',
    marginBottom: '8px',
  },
  progressValues: { textAlign: 'center' },
}));

function ProgressBarDialog(props) {
  const theme = useTheme();
  const classes = useStyles();

  const { progressBarValues } = props;

  // MIN = Minimum expected value
  // MAX = Maximium expected value
  // Function to normalise the values (MIN / MAX could be integrated)
  const normalise = (value, MIN, MAX) => ((value - MIN) * 100) / (MAX - MIN);

  const value = props.value ? props.value : progressBarValues?.progressBarValue ? progressBarValues.progressBarValue : 0;

  useEffect(() => {
    if (value) {
      console.log('value', value);
    }
  }, [value]);

  const fileName = props.fileName ? props.fileName : progressBarValues?.progressBarFileName ? progressBarValues.progressBarFileName : '';

  const fileCount = props.fileCount ? props.fileCount : progressBarValues?.progressBarFileCount ? progressBarValues.progressBarFileCount : '';

  const fullValue = props.fullValue ? props.fullValue : progressBarValues?.progressBarFullValue ? progressBarValues.progressBarFullValue : 0;

  const fullCount = props.fullCount ? props.fullCount : progressBarValues?.progressBarFullCount ? progressBarValues.progressBarFullCount : '';

  const open = props.open ? props.open : progressBarValues?.showProgressBarDialog ? progressBarValues.showProgressBarDialog : false;

  return (
    <Translation ns={['common']}>
      {(t) => (
        <>
          <Dialog
            aria-labelledby="project-bank-preview-dialog"
            classes={{ paper: classes.dialogPaper }}
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={props.onCancelAdding}
          >
            <DialogHeader
              title={
                <>
                  <span
                    style={{
                      flex: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {props.header
                      ? props.header
                      : fileName
                        ? fileName
                        : t('common.downloading')}
                  </span>
                  {fileCount && fullCount ? (
                    <span style={{ flexShrink: 0, marginLeft: 8 }}>
                      {fileCount}/{fullCount}
                    </span>
                  ) : null}
                </>
              }
              onClose={props.onClose}
            />
            {value && value !== 0 && fullValue !== 0 ? (
              <DialogContent className={classes.dialogContent}>
                <Grid
                  container
                  spacing={2}
                  direction="column"
                  className={classes.gridContainer}
                >
                  <Grid item className={classes.progressBar}>
                    <LinearProgress
                      variant={'determinate'}
                      value={normalise(value, 0, fullValue)}
                    />
                  </Grid>

                  <Grid item className={classes.progressValues}>
                    <Typography variant="body2">{`${value && fullValue
                      ? value + '/' + fullValue + ' MB'
                      : ''
                      }`}</Typography>
                  </Grid>
                </Grid>
              </DialogContent>
            ) : (
              <DialogContent className={classes.dialogContent}>
                <Grid
                  container
                  spacing={2}
                  direction="column"
                  className={classes.gridContainer}
                >
                  <Grid item className={classes.progressBar}>
                    <LinearProgress

                    />
                  </Grid>

                  <Grid item className={classes.progressValues}>
                    <Typography variant="body2">{`Loading`}</Typography>
                  </Grid>
                </Grid>
              </DialogContent>
            )}
            <Divider />
            <DialogActions className={classes.dialogActions}>
              <Button onClick={props.onCancelAdding}>
                {t('common.cancel')}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Translation>
  );
}

export default ProgressBarDialog;
